import React from 'react';
import Link from 'gatsby-link';

import './Logo.module.css';

import LogoImage from 'Images/montadrill_logo.gif';

function Logo() {
  return (
    <h1>
      <Link to="/">
        <img src={LogoImage} styleName="Logo"alt="Montadrill Logo" />
      </Link>
    </h1>
  );
}

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Shared/Logo/Logo.js